import React from 'react';
import styled from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isNotNullAndUndefined = (num) => {
  return num !== void 0 && num !== null;
};
const StyledBadge = styled.div(({
  theme,
  color,
  hidden,
  top,
  right,
  bottom,
  left,
  width,
  height,
  fontSize
}) => `
  display: block;
  position: absolute;
  z-index: 1;
  text-align: center;
  color: ${theme.colors.white};
  border-radius: 50%;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  padding: 0;
  opacity: ${hidden ? "0" : "1"};
  background-color: ${color ? color : theme.brand.primary};
  ${isNotNullAndUndefined(top) ? `top: ${top}px` : ""};
  ${isNotNullAndUndefined(bottom) ? `bottom: ${bottom}px` : ""};
  ${isNotNullAndUndefined(left) ? `left: ${left}px` : ""};
  ${isNotNullAndUndefined(right) ? `right: ${right}px` : ""};
  width: ${isNotNullAndUndefined(width) ? `${width}px` : "16px"};
  height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  line-height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  font-size: ${isNotNullAndUndefined(fontSize) ? `${fontSize}px` : "8px"};
`);
const Badge = (_a) => {
  var _b = _a, { text } = _b, rest = __objRest(_b, ["text"]);
  return /* @__PURE__ */ React.createElement(StyledBadge, __spreadValues({}, rest), text);
};

export { Badge };
